import { createAction } from 'redux-actions';

export const getEventProductsSmallZoneRequested = createAction('GET_EVENT_PRODUCTS_SMALL_ZONE_REQUEST');
export const getEventProductsSmallZoneReceived = createAction('GET_EVENT_PRODUCTS_SMALL_ZONE_RECEIVED');
export const getEventProductsSmallZoneReceiveFailure = createAction('GET_EVENT_PRODUCTS_SMALL_ZONE_RECEIVE_FAILURE');
export const getEventProductsSmallZoneClear = createAction('GET_EVENT_PRODUCTS_SMALL_ZONE_CLEAR');

export const getEventProductsStandardZoneRequested = createAction('GET_EVENT_PRODUCTS_STANDARD_ZONE_REQUEST');
export const getEventProductsStandardZoneReceived = createAction('GET_EVENT_PRODUCTS_STANDARD_ZONE_RECEIVED');
export const getEventProductsStandardZoneReceiveFailure = createAction('GET_EVENT_PRODUCTS_STANDARD_ZONE_RECEIVE_FAILURE');
export const getEventProductsStandardZoneClear = createAction('GET_EVENT_PRODUCTS_STANDARD_ZONE_CLEAR');

export const getEventProductsBigZoneRequested = createAction('GET_EVENT_PRODUCTS_BIG_ZONE_REQUEST');
export const getEventProductsBigZoneReceived = createAction('GET_EVENT_PRODUCTS_BIG_ZONE_RECEIVED');
export const getEventProductsBigZoneReceiveFailure = createAction('GET_EVENT_PRODUCTS_BIG_ZONE_RECEIVE_FAILURE');
export const getEventProductsBigZoneClear = createAction('GET_EVENT_PRODUCTS_BIG_ZONE_CLEAR');

export const getEventProductsGrandZoneRequested = createAction('GET_EVENT_PRODUCTS_GRAND_ZONE_REQUEST');
export const getEventProductsGrandZoneReceived = createAction('GET_EVENT_PRODUCTS_GRAND_ZONE_RECEIVED');
export const getEventProductsGrandZoneReceiveFailure = createAction('GET_EVENT_PRODUCTS_GRAND_ZONE_RECEIVE_FAILURE');
export const getEventProductsGrandZoneClear = createAction('GET_EVENT_PRODUCTS_GRAND_ZONE_CLEAR');

export const getEventProductsRequested = createAction('GET_EVENT_PRODUCTS_REQUEST');
export const getEventProductsReceived = createAction('GET_EVENT_PRODUCTS_RECEIVED');
export const getEventProductsReceiveFailure = createAction('GET_EVENT_PRODUCTS_RECEIVE_FAILURE');
export const getEventProductsClear = createAction('GET_EVENT_PRODUCTS_CLEAR');

export const setSelectedOrganizers = createAction('SET_SELECTED_ORGANIZER');
export const clearSelectedOrganizers = createAction('CLEAR_SELECTED_ORGANIZER');

export const setSearchCondition = createAction('SET_SEARCH_CONDITION');
export const clearSearchCondition = createAction('CLEAR_SEARCH_CONDITION');

export const setViewMode = createAction('SET_VIEW_MODE');
